/* eslint-disable react/display-name */
import { FiltersWidgetWrapper } from '../../filters-widget/FiltersWidget';
import type { FiltersWidgetEntity } from '../../filters-widget/FiltersWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderFiltersWidget(widget: FiltersWidgetEntity, options: TWidgetRendererOptions): TRenderWidget {
  return () => <FiltersWidgetWrapper entity={widget} options={options} />;
}
